class FilterDrawer extends HTMLElement {
  els = {
    closeTrigger: this.querySelector('[data-filter-drawer-el="closeTrigger"]'),
    openTrigger: this.querySelector('[data-filter-drawer-el="trigger"]'),
    backdrop: this.querySelector('[data-filter-drawer-el="backdrop"]'),
    applyFilters: this.querySelector('[data-filter-drawer-el="applyFilters"]'),
    panel: this.querySelector('[data-filter-drawer-el="panel"]'),
  }

  connectedCallback () {
    this.addEventListeners()

    if (window.matchMedia('(min-width: 1201px)').matches) {
      this.remove()
    } else {
      document.querySelector('.src-Facets_DesktopNav').remove()
    }
  }

  addEventListeners () {
    this.els.openTrigger.addEventListener('click', this.handleOpen.bind(this))
    this.els.closeTrigger.addEventListener('click', this.handleClose.bind(this))
    this.els.backdrop.addEventListener('click', this.handleClose.bind(this))
    this.els.applyFilters.addEventListener('click', this.handleClose.bind(this))
  }

  handleOpen () {
    this.els.panel.setAttribute('aria-hidden', 'false')
  }

  handleClose () {
    this.els.panel.setAttribute('aria-hidden', 'true')
  }
}

if (!customElements.get('filter-drawer')) {
  customElements.define('filter-drawer', FilterDrawer)
}
